import {TableType} from "../constants";
import {MenuGroup} from "./menu";

export class Table {
    id: number;
    host_id: number;
    idtag: string;
    number: string;
    type: TableType;
    is_active: boolean;
    text: string;

    constructor(init?: Partial<MenuGroup>) {
        Object.assign(this, init);
    }
}
